import React, { useCallback } from "react";

import { useTranslation } from "react-i18next";

import CreateSmartlistButton from "./CreateSmartlistButton";
import { SmartlistType } from "../../api/MediaAPI.types";
import GenericSmartlistList from "../common/smartlist/GenericSmartlistList";

import type { JSX } from "react";

function SmartlistList(): JSX.Element {
  const { t } = useTranslation("editor-smartlist");
  const getDeleteBody = useCallback(
    (label: string): string => t("deleteBody", { smartlist: label }),
    [t],
  );

  const breadcrumbs = [
    {
      name: t("editor-menu:publishing-management"),
      url: "/smartlist",
    },
    {
      name: t("sectionTitle"),
    },
  ];

  return (
    <GenericSmartlistList
      breadcrumbs={breadcrumbs}
      createButton={<CreateSmartlistButton />}
      deleteCompleteText={t("deleteComplete")}
      deleteTitle={t("deleteTitle")}
      editUrlPrefix="smartlist"
      getDeleteBody={getDeleteBody}
      smartlistTypes={[SmartlistType.STANDARD, SmartlistType.AUTO]}
      tableTitle={t("sectionTitle")}
    />
  );
}

export default SmartlistList;
